import { gql } from "@/__generated__/gql";

export const USERS_WITH_FEED_POSTS_QUERY = gql(`
  query OrganizationUsersWithFeedPosts(
    $orgId: ID!,
    $imageSize: Int!
  ) {
    node(id: $orgId) {
      id
      ... on Organization {
        users(hasPostedToFeed: true) {
          edges {
            node {
              id
              uuid
              firstName
              lastName
              profilePhoto {
                id
                url(size: $imageSize)
              }
            }
          }
        }
      }
    }
  }
`);
